export default __webpack_public_path__ + "static/media/@marina.frodrigues.175ae10e.jpg";